import iconsObj from '../../assets/icons/iconsObj';
import CLMaskIcon from '../CLMaskIcon/CLMaskIcon';
import React, {MouseEvent} from 'react';
import classNames from 'classnames';
import './CLMenuArrow.scss';
import {AutomationProps} from 'common/src/modules/automation/automation.types';

export interface CLMenuArrowProps extends AutomationProps {
  startPosition?: 'up' | 'down' | 'right' | 'left' | 'none';
  className?: string;
  size?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  icon?: string;
}

function CLMenuArrow({
  startPosition = 'none',
  className = '',
  size = '10px',
  icon = iconsObj.menus.dropDownArrow,
  qaHook = '',
  onClick = () => {},
}: CLMenuArrowProps) {
  return (
    <CLMaskIcon
      qaHook={qaHook}
      src={icon}
      size={size}
      className={classNames('cl_common_menu_arrow', startPosition, className)}
      onClick={onClick}
    />
  );
}

export default CLMenuArrow;
